export default __webpack_public_path__ + "static/media/search-notification.c3e63333.svg";